<ng-container *transloco="let t">
  <form class="step" (submit)="validateStepAndContinue($event)" novalidate>
    <dx-validation-group #validationGroup>
      <pxw-text-field
        class="username"
        [label]="t('account.username')"
        [placeholder]="t('account.username')"
        [(value)]="registrationSharedService.registrationData.account.username"
        [disabled]="true"
        stylingMode="underlined"
      ></pxw-text-field>
      <pxw-text-field
        [label]="t('account.password')"
        [placeholder]="t('account.password')"
        mode="password"
        [(value)]="registrationSharedService.registrationData.account.password"
        [rules]="[
          { type: 'required', message: t('account.passwordRequired') },
          { type: 'stringLength', min: 8, message: t('account.passwordMin') }
        ]"
        stylingMode="underlined"
      ></pxw-text-field>
    </dx-validation-group>
    <div class="button-wrapper" style="padding-top: 0 !important">
      <pxw-button display="block" type="warning" size="md" (click)="prev()">
        <i class="ci-short_left"></i>
        {{ t('general.back') }}
      </pxw-button>
      <pxw-button mode="submit" display="block" type="warning" size="md">{{
        buttonNextText
      }}</pxw-button>
    </div>
  </form>
</ng-container>
